import React from 'react'
const OverlayContainer = ({children}) => {
  return <div style={{position: "relative", width: "100%"}}>
    {children}
  </div>
}

const Overlay = ({children, allowPointerEvents = false}) => {
  const overlayStyle = {
    pointerEvents: allowPointerEvents ? null : "none",
    zIndex: 999,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    minHeight: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
  }

  return <div style={overlayStyle}>
    {children}
  </div>
}

export {
  OverlayContainer,
  Overlay,
}